__turbopack_context__.v({
  "container": "AudurButtonLink-module-scss-module__QxpAnG__container",
});
